import API from "@/API/Services/APIService";

export default{
    GET_COMPANIES(query) {
        return API().get(`/companies${query}`)
    }
}